import React, { useState, useEffect, Suspense } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios'
import { Markup } from 'interweave';
import LoadingBar from 'react-top-loading-bar'
import {Helmet} from "react-helmet";

import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import Footer from '../Footer/Footer';

import styles from '../../App.module.css';
import classes from './Page.module.css'

function Page() {
    const navigate = useNavigate();
    const { id, name } = useParams();
    const [pageContent, setPageContent] = useState(null);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        try{
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        }catch(ex){}
      }, []);

    useEffect(() => {
        setProgress(10);
        axios.post(`${process.env.REACT_APP_API_URL}/api/page.php`, {
            id: id,
        }, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        }).then(res => {
            // console.log(res.data.data);
            if(res.data.status === 'success') {
                setPageContent(res.data.data);
            }else {
                navigate('/404');
            }
            setProgress(100);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }).catch(err => {
            console.log(err);
        })
    } , [id, name])

    return (
        <>
            {
                pageContent && <Helmet>
                    <title>{pageContent.title || 'Page'} - Wesharez</title>
                    <meta name="description" content={pageContent.content ? pageContent.content.replace(/<[^>]*>?/gm, '').slice(0, 270) : 'Page'} />
                    <meta name="keywords" content={pageContent.tags || ''} />
                </Helmet>
            }
            <LoadingBar
                color='#f11946'
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
            />
            <Header />
            <div className={styles.main_body}>
                <Suspense fallback="<div>Please wait...</div>">
                    <Sidebar />
                </Suspense>
                <Suspense fallback="<div>Please wait...</div>">
                    <div className={styles.main_content + ` main-content`}>
                        <ins className='adsbygoogle p-4 pb-0'
                            style={{ display: 'block' }}
                            data-ad-client='ca-pub-8126596259429304'
                            data-ad-slot='5153011292'
                            data-ad-format='auto'
                        />
                        <div className={classes.page_component + ` p-4`}>
                            {
                                pageContent && <>
                                    <div className={classes.page_name}>
                                        <h3>{pageContent.title}</h3>
                                    </div>
                                    <div className={classes.page_content}>
                                        {
                                            pageContent.pic && <div className={classes.image}><img src={pageContent.pic} alt={pageContent.title} /></div>
                                        }
                                        <div><Markup content={pageContent.content} /></div>
                                    </div>
                                </>
                            }
                        </div>
                        <Footer />
                    </div>
                </Suspense>
            </div>
        </>
    )
}

export default Page